import 'animate.css';
import {Grid} from '@mui/material';

import {registerSteps} from '../SignIn';
import addressIcon from 'assets/img/location.svg';
import AutoCompleteField from 'components/Formik/AutoCompleteField';
import CustomTextField from 'components/AddOrEditForm/fields/TextField';
import FormikField from 'components/Formik/FormikField';
import { cityOptions, provinceOptions } from 'helpers/findUserLocation';

export const Fields = (props) => {
  const {province, steps, isAgent} = props;

  if (registerSteps.signup === steps)
    return (
      <>
        {isAgent ? (
          <>
            <Grid item xs={12}>
              <CustomTextField
                fullWidth
                showValueCenter
                type='text'
                name='firstName'
                placeholder='نام دستیار'
                {...props}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomTextField
                showValueCenter
                fullWidth
                name='lastName'
                type='text'
                placeholder='نام خانوادگی دستیار'
                {...props}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <CustomTextField
                fullWidth
                type='text'
                showValueCenter
                name='firstName'
                placeholder='نام اسکن کننده *'
                {...props}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomTextField
                fullWidth
                type='text'
                showValueCenter
                name='lastName'
                placeholder='نام خانوادگی اسکن کننده *'
                {...props}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomTextField
                fullWidth
                type='text'
                showValueCenter
                name='scanCenterName'
                placeholder='نام مرکز اسکن *'
                {...props}
              />
            </Grid>
            <Grid item xs={12}>
              <AutoCompleteField
                placeholder='استان *'
                name='provinceId'
                options={provinceOptions(province)}
                {...props}
              />
            </Grid>
            <Grid item xs={12}>
              <AutoCompleteField
                placeholder='شهر *'
                name='cityId'
                options={cityOptions(province, props.values.provinceId?.id)}
                // disabled={!props.values.provinceId}
                {...props}
              />
            </Grid>
            <Grid item xs={12}>
              <FormikField
                {...props}
                fullWidth
                showValueCenter
                name='address'
                placeholder='آدرس'
                icon={addressIcon}
              />
            </Grid>
          </>
        )}
      </>
    );
};
